'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_localization_package$() {
  this.Lapp_localization_package$__f_LocalizedText$lzy1 = null;
  this.Lapp_localization_package$__f_LocalizedTextbitmap$1 = false;
  this.Lapp_localization_package$__f_LocalizedTextOf$lzy1 = null;
  this.Lapp_localization_package$__f_LocalizedTextOfbitmap$1 = false;
  this.Lapp_localization_package$__f_LocalizedTextOfValue$lzy1 = null;
  this.Lapp_localization_package$__f_LocalizedTextOfValuebitmap$1 = false;
}
export { $c_Lapp_localization_package$ as $c_Lapp_localization_package$ };
$c_Lapp_localization_package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_localization_package$.prototype.constructor = $c_Lapp_localization_package$;
/** @constructor */
function $h_Lapp_localization_package$() {
}
export { $h_Lapp_localization_package$ as $h_Lapp_localization_package$ };
$h_Lapp_localization_package$.prototype = $c_Lapp_localization_package$.prototype;
$c_Lapp_localization_package$.prototype.LocalizedText__Lframework_localization_LocalizationSupport$LocalizedText$ = (function() {
  if ((!this.Lapp_localization_package$__f_LocalizedTextbitmap$1)) {
    this.Lapp_localization_package$__f_LocalizedText$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_localization_LocalizationSupport$LocalizedText$(this);
    this.Lapp_localization_package$__f_LocalizedTextbitmap$1 = true;
  }
  return this.Lapp_localization_package$__f_LocalizedText$lzy1;
});
$c_Lapp_localization_package$.prototype.LocalizedTextOf__Lframework_localization_LocalizationSupport$LocalizedTextOf$ = (function() {
  if ((!this.Lapp_localization_package$__f_LocalizedTextOfbitmap$1)) {
    this.Lapp_localization_package$__f_LocalizedTextOf$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_localization_LocalizationSupport$LocalizedTextOf$(this);
    this.Lapp_localization_package$__f_LocalizedTextOfbitmap$1 = true;
  }
  return this.Lapp_localization_package$__f_LocalizedTextOf$lzy1;
});
$c_Lapp_localization_package$.prototype.LocalizedTextOfValue__Lframework_localization_LocalizationSupport$LocalizedTextOfValue$ = (function() {
  if ((!this.Lapp_localization_package$__f_LocalizedTextOfValuebitmap$1)) {
    this.Lapp_localization_package$__f_LocalizedTextOfValue$lzy1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lframework_localization_LocalizationSupport$LocalizedTextOfValue$(this);
    this.Lapp_localization_package$__f_LocalizedTextOfValuebitmap$1 = true;
  }
  return this.Lapp_localization_package$__f_LocalizedTextOfValue$lzy1;
});
var $d_Lapp_localization_package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_localization_package$, "app.localization.package$", ({
  Lapp_localization_package$: 1,
  Lframework_localization_LocalizationSupport: 1
}));
export { $d_Lapp_localization_package$ as $d_Lapp_localization_package$ };
var $n_Lapp_localization_package$;
function $m_Lapp_localization_package$() {
  if ((!$n_Lapp_localization_package$)) {
    $n_Lapp_localization_package$ = new $c_Lapp_localization_package$();
  }
  return $n_Lapp_localization_package$;
}
export { $m_Lapp_localization_package$ as $m_Lapp_localization_package$ };
//# sourceMappingURL=app.localization.package$.js.map
